import AgainstAbuseGrid from "components/grids/against-abuse";
import Protesting from "components/svgs/protesting";
import Selfie from "components/svgs/selfie";
import HoldingHands from "components/svgs/holding-hands";
import Mother from "components/svgs/mother";
import Gavel from "components/svgs/gavel";
import Helping from "components/svgs/helping";
import Hands from "components/svgs/four-hands";
import House from "components/svgs/house";
import Women from "components/svgs/women";
import * as React from 'react';
export default {
  AgainstAbuseGrid,
  Protesting,
  Selfie,
  HoldingHands,
  Mother,
  Gavel,
  Helping,
  Hands,
  House,
  Women,
  React
};